import styled from 'styled-components';

export const ContentWrapper = styled.main`
  display: flex;
  align-items: stretch;
  flex-direction: column;
  justify-content: flex-start;
  gap: var(--spacing-large);
  padding-block: var(--spacing-large);

  @media (width >= 48rem) {
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-around;

    & > div {
      flex: 1;
    }
  }
`;

export const CheckOutDetails = styled.div`
  @media (width >= 48rem) {
    order: -1;
  }
`;

export const CheckoutSection = styled.section`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--spacing-base);

  > div:not(.contact-section) {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: var(--spacing-base);
    width: 100%;
  }
`;

export const OrderDetails = styled.div`
`;
